import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class AbstractTab extends AbstractProvidedClass {
    activate() {
        this.button.addClass('-is-active');
    }

    deactivate() {
        this.button.removeClass('-is-active');
    }

    resizeWindow() { }

    createButton(tabContainer, isFirst) {
        this.button = this.p.createDiv()
            .parent(tabContainer)
            .class('planner-tab')
            .html(this.icon)
            .attribute('data-tooltip', this.tooltip)
            .style('z-index', 2)
            .mousePressed(() => this.sideBar.setTab(this.name));
    }
}
